// @flow
import * as PublicAccountPagesConstants from "../../Constants/PublicAccountPages/publicAccountPagesConstants";

export function userRegisterFormElementValueChange(formElement: string, value: string): Object {
  return {
    type: PublicAccountPagesConstants.USER_REGISTER_FORM_ELEMENT_VALUE_CHANGE,
    payload: { formElement, value }
  };
}

export function userRegisterControlElementValueChange(controlElement: string, value: string): Object {
  return {
    type: PublicAccountPagesConstants.USER_REGISTER_CONTROL_ELEMENT_VALUE_CHANGE,
    payload: { controlElement, value }
  };
}

export function userRegisterFormSubmit(formElements: Object, request_id: number, related_secret: string): Object {
  return {
    type: PublicAccountPagesConstants.USER_REGISTER_FORM_SUBMIT_REQUEST,
    payload: { formElements, request_id, related_secret }
  };
}

export function userRegisterFormErrorRelease(): Object {
  return {
    type: PublicAccountPagesConstants.USER_REGISTER_FORM_ERROR_RELEASE
  };
}



// WEBPACK FOOTER //
// ./src/Actions/PublicAccountPages/userregister.js